<template>
  <div class="mobile-login-form">
    <div>
      <div class="glob-error">
        <!-- 有错误提示 -->
        <div class="error-box-g" v-if="mobileLoginError.hasError">
          <div>
            <span class="warn-icon">
              <unex-icon svg="warn"></unex-icon>
            </span>
            <span>{{ mobileLoginError.errMessage }}</span>
          </div>
        </div>
      </div>
    </div>
    <form
      class="login-form"
      ref="mobileForm"
      :model="mobileForm"
      @keyup.enter="mobileLogin()"
    >
      <div class="input-line">
        <div class="form-label">{{ $t("frame.mobile") }}</div>
        <el-input
          :class="{
            'v-error': mobileLoginError.mobileError
          }"
          :placeholder="$t('frame.please_enter')"
          v-model="mobileForm.mobile"
          autocomplete="off"
          name="l-mobile"
          @blur="mobileLoginValidate('mobile')"
          @change="clearError('mobile')"
        ></el-input>
        <transition name="heightchange">
          <div class="error-box">
            <span>{{ mobileLoginError.mobileError }}</span>
          </div>
        </transition>
      </div>
      <div class="input-line">
        <div class="captcha-input-wrap">
          <div class="form-label">{{ $t("frame.pic_code") }}</div>
          <el-input
            :class="{
              'v-error': mobileLoginError.loginCodeError
            }"
            :placeholder="$t('frame.please_enter')"
            v-model="mobileForm.loginCode"
            autocomplete="off"
            name="l-loginCode"
            @blur="mobileLoginValidate('loginCode')"
            @change="clearError('mobile')"
          ></el-input>
          <div class="captchaUrl-wrap">
            <el-tooltip popper-class="login-tooltip" placement="top">
              <div
                slot="content"
                class="tooltip-content"
                style="color: #666666 ;"
              >
                {{ $t("frame.renew_info") }}
              </div>
              <img
                v-if="captchaUrlLoad"
                :src="captchaUrl"
                @error="getCaptcha"
                class="validate-code"
                @click="getCaptcha"
              />
              <img v-else :src="captchaUrl" @click="getCaptcha" />
            </el-tooltip>
          </div>
        </div>
        <transition name="heightchange">
          <div class="error-box">
            <span>{{ mobileLoginError.loginCodeError }}</span>
          </div>
        </transition>
      </div>
      <div class="input-line">
        <div class="captcha-input-wrap">
          <div class="form-label">
            {{ $t("frame.code_validate") }}
          </div>
          <el-input
            :class="{
              'v-error': mobileLoginError.codeError
            }"
            :placeholder="$t('frame.please_enter')"
            v-model="mobileForm.code"
            autocomplete="off"
            name="l-code"
            @blur="mobileLoginValidate('code')"
            @change="clearError('mobile')"
          ></el-input>
          <div class="captchaUrl-wrap warp-code" @click="getMobileCode">
            <span>{{ pcodetext }}</span>
          </div>
        </div>
        <transition name="heightchange">
          <div class="error-box">
            <span>{{ mobileLoginError.codeError }}</span>
          </div>
        </transition>
      </div>
      <div style="text-align: left;">
        <el-checkbox v-model="mobileForm.rememberMe">{{
          $t("frame.automaticlogin")
        }}</el-checkbox>
      </div>
      <el-button class="submit" @click="mobileLogin()" type="primary">
        {{ loginStauts }}
        <i class="unex-icon-arrow-right"></i>
      </el-button>
    </form>
    <div class="forget-span">
      <span @click="setHref('account')" style="color:#3366FF"
        >账号密码登录</span
      >
      <span @click="setHref('forget')" style="color:#999999">{{
        $t("frame.forget_password")
      }}</span>
    </div>
  </div>
</template>
<script>
import cookie from "js-cookie";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      loginStauts: this.$t("frame.sign_in"),
      pcodetext: this.$t("frame.get_validate"),
      pcodeCount: 1,
      //手机登录
      mobileForm: {
        mobile: cookie.get("l-mobile"),
        code: null,
        loginCode: null,
        rememberMe: false
      },
      //手机登录错误信息
      mobileLoginError: {
        hasError: false,
        errMessage: null,
        mobileError: null,
        codeError: null,
        loginCodeError: null
      }
    };
  },
  computed: {
    ...mapState({
      captchaUrl: state => state.frame.login.captchaUrl,
      captchaUrlLoad: state => state.frame.login.captchaUrlLoad
    })
  },
  methods: {
    ...mapMutations({
      setLoginType: "frame/login/setLoginType"
    }),
    ...mapActions({
      getCaptcha: "frame/login/getCaptcha"
    }),
    setHref(type) {
      this.setLoginType(type);
      this.getCaptcha();
    },
    setIntervalTime() {
      if (this.pcodeCount == 1) {
        window.clearInterval(this.InterValObj); //停止计时器
        this.pcodetext = this.$t("frame.get_validate");
      } else {
        this.pcodeCount--;
        this.pcodetext = this.pcodeCount + "s" + this.$t("frame.Re_acquire");
      }
    },
    //获取短信验证码
    async getMobileCode() {
      const { mobile, loginCode } = this.mobileForm;
      if (this.pcodeCount === 1 && mobile && loginCode) {
        this.pcodeCount = 60;
        this.InterValObj = window.setInterval(this.setIntervalTime, 1000);
        this.mobileLoginError.mobileError = "";
        const res = await this.$store.dispatch("frame/getMobileCode", {
          mobile: this.mobileForm.mobile,
          imageCode: loginCode
        });
        if (!res.success) {
          let code = res.code.substring(4);
		  // truly code
          if (code == 2112 || code == 2113 || code == 2127) {
            this.mobileLoginError.mobileError = res.message;
          } else if (code == 2016 || failImageCode(code)) {
            this.$message({
              message: res.message,
              type: "error",
              center: true,
              duration: 2000
            });
          }
          window.clearInterval(this.InterValObj); //停止计时器
          this.pcodeCount = 1;
          this.pcodetext = this.$t("frame.get_validate");
          this.getCaptcha();
        } else {
          this.mobileLoginError.hasError = true;
          this.mobileLoginError.errMessage = this.$t("frame.please_check");
          setTimeout(() => {
            this.mobileLoginError.hasError = false;
          }, 3000);
        }
      }
      function failImageCode(code) {
        return code === "0503";
      }
    },
    async mobileLogin() {
      let self = this;
      if (this.mobileForm.mobile && this.mobileForm.code) {
        this.mobileLoginError.hasError = false;
        let res = await this.$store.dispatch(
          "frame/mobileLogin",
          this.mobileForm
        );
        if (!res.success) {
          let code = res.code.substring(4);
          if (code == 503) {
            this.mobileLoginError.loginCodeError = res.message;
          } else if (code == 2110) {
            this.mobileLoginError.codeError = res.message;
          } else if (code == 2113) {
            this.mobileLoginError.mobileError = res.message;
          } else if (code == 303 || code == 3004 || code == 310) {
            this.mobileLoginError.hasError = true;
            this.mobileLoginError.errMessage = res.message;
          }
          setTimeout(() => {
            this.mobileLoginError.hasError = false;
          }, 3000);
          this.showDialog = res.code.includes(2117);
          this.getCaptcha();
        } else {
          cookie.set("l-mobile", self.mobileForm.mobile);
          window.clearInterval(this.InterValObj); //停止计时器
          this.pcodetext = this.$t("frame.get_validate");
          this.$emit("afterLogin", res);
        }
      } else {
        for (let item in this.mobileForm) {
          this.mobileLoginValidate(item);
        }
      }
    },
    //手机号码方式验证
    mobileLoginValidate(name) {
      if (name === "mobile" && !this.mobileForm.mobile) {
        this.mobileLoginError.mobileError = this.$t(
          "frame.please_phone_number"
        );
      } else if (name === "mobile" && this.mobileForm.mobile) {
        this.mobileLoginError.mobileError = "";
      }

      if (name === "code" && !this.mobileForm.code) {
        this.mobileLoginError.codeError = this.$t("frame.please_SMS_number");
      } else if (name === "code" && this.mobileForm.mobile) {
        this.mobileLoginError.codeError = "";
      }

      if (name === "loginCode" && !this.mobileForm.loginCode) {
        this.mobileLoginError.loginCodeError = this.$t(
          "frame.please_image_number"
        );
      } else if (name === "username" && this.mobileForm.loginCode) {
        this.mobileLoginError.loginCodeError = "";
      }
    },
    clearError() {
      this.mobileLoginError.hasError = false;
    }
  }
};
</script>
